import React from "react";


 export default function ErrorBar(){


    return(
        <>
        <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_bdnjxekx.json"  background="transparent"  speed="1"  style={{width: "41px"}}  loop  autoplay></lottie-player>
        </>
    )
}